import React from 'react';
export const AppDataContext = React.createContext({});
export const AppDataProvider = AppDataContext.Provider;
export const MapGlobalContext = React.createContext({});
export const DEGlobalContext = React.createContext({});
export const AlertsGlobalContext = React.createContext({});
export const WindowLiveGlobalContext = React.createContext({});
export const OverlayGlobalContext = React.createContext({});
export const PageGlobalContext = React.createContext({});
